import { BaseRestApi, TRestErrorHandler, RestResponse, ISpringResponse } from '@oceanjs/core';
import { SpringRestConfig } from './SpringRestConfig';
import { ComponentTypes } from './model';
import { AxiosRequestConfig } from 'axios';

const resource = SpringRestConfig.endpoints.componenttypes
class ComponentTypeApiImpl extends BaseRestApi {

  public async findAll(onError?: TRestErrorHandler): Promise<RestResponse<ISpringResponse<ComponentTypes>>> {

    const config: AxiosRequestConfig = { headers: { 'Accept': 'application/hal+json' }};
    const result = this.request<ISpringResponse<ComponentTypes>>('get', resource, onError, undefined, config);
    if (result == null) { Promise.reject(); }

    return result;
  }

}
export const ComponentTypeApi = new ComponentTypeApiImpl(resource);
